// extracted by mini-css-extract-plugin
export default {"assetInfo":"Page_assetInfo__qXIP5","assetDetail":"Page_assetDetail__I2Mo5","asset":"Page_asset__n92JM"};